import mammoth from 'mammoth';

/**
 * Extracts text/HTML content from a file
 * @param {File|Blob} file - The file or blob object
 * @param {string} [nameOverride] - Optional name override if file.name is missing
 * @returns {Promise<string>} - Extracted HTML or text
 */
export const extractFileContent = async (file, nameOverride) => {
    const fileName = nameOverride || file.name || "";
    const fileType = fileName.includes('.') ? fileName.split('.').pop().toLowerCase() : "";
    const mimeType = file.type || "";

    const isDocx = fileType === 'docx' || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    const isTxt = fileType === 'txt' || fileType === 'md' || mimeType === 'text/plain';
    const isPdf = fileType === 'pdf' || mimeType === 'application/pdf';

    if (isDocx) {
        try {
            const arrayBuffer = await file.arrayBuffer();
            const result = await mammoth.convertToHtml({ arrayBuffer });
            return result.value; // The generated HTML
        } catch (error) {
            console.error('Error extracting Word content:', error);
            return `<p>[Error extracting Word content from ${fileName || 'unnamed file'}]</p>`;
        }
    }

    if (isPdf) {
        // For PDF, we'll need a different library or just show a placeholder for now
        // since pdf-parse is usually Node-only and pdf.js is heavy.
        return `<h1>${fileName || 'PDF Document'}</h1><p>PDF content extraction not yet implemented in editor. Please use the chat to analyze this document.</p>`;
    }

    if (isTxt) {
        try {
            const text = await file.text();
            return text.replace(/\n/g, '<br>');
        } catch (error) {
            console.error('Error extracting text content:', error);
            return `<p>[Error extracting text from ${fileName || 'unnamed file'}]</p>`;
        }
    }

    return `<h1>${fileName || 'Document'}</h1><p>Preview not available for this file type.</p>`;
};
